module.exports = __webpack_public_path__ + "static/main_img-06dcf2d090e9d2b5a5443bbf492f31ec.png";